import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

export const Spinner = ({ label = 'Betöltés…', className }: { label?: string; className?: string }) => (
  <div className={cn('flex items-center justify-center gap-3 p-8 text-ink-soft', className)} role="status">
    <Loader2 className="size-7 animate-spin" aria-hidden="true" />
    <span className="text-base">{label}</span>
  </div>
);
